import type { SiteCatalogProduct } from '~/lib/site-catalog'

export const SITE_UI_KEY = Symbol('site-ui')

/** UI-состояние витрины: модалки товара и корзины */
export class SiteUiState {
  cartDrawerOpen = $state(false)
  productModalOpen = $state(false)
  activeProduct = $state<SiteCatalogProduct | null>(null)

  openCartDrawer() {
    this.cartDrawerOpen = true
  }

  closeCartDrawer() {
    this.cartDrawerOpen = false
  }

  openProduct(product: SiteCatalogProduct) {
    this.activeProduct = product
    this.productModalOpen = true
  }

  closeProduct() {
    this.productModalOpen = false
    this.activeProduct = null
  }
}
